import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { STRUCTURED_SESSION_IDS, StructuredSessionId } from '@backrs_ui/grow-ui/src/models/models';
import { LubavSession } from '@backrs_ui/grow-ui/src/redux/coachLubav/coachLubav.api';

export const getSessionRoute = (session: LubavSession): string => {
  const { type, id } = session;

  switch (type) {
    case 'office_hours':
      return `${APP_ROUTE.HOME}?session_id=${id}`;
    case 'coaching_dashboard':
      if (!session.coaching_user_id) return APP_ROUTE.COACHING_DASHBOARD;

      return `${APP_ROUTE.COACHING_DASHBOARD_MEMBER.replace(':memberId', String(session.coaching_user_id))}?session_id=${id}`;
    default:
      if (STRUCTURED_SESSION_IDS.includes(type as StructuredSessionId)) {
        return `${APP_ROUTE.OFFICE_HOURS_SESSION.replace(':id', type)}?session_id=${id}`;
      }

      // still-legacy solution sessions (resume_builder)
      return `${APP_ROUTE.SOLUTION_SESSION.replace(':id?', type)}?session_id=${id}`;
  }
};
